var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.class_css},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }